import { useEffect, useState } from "react";
import { getContentById } from "../../api/vod/vod";
import { readCache } from "../../utils/readCache";
import { publicationStart } from "../../utils/publication";

const needsMetadata = item => item?.id && !["PROGRAM", "CHANNEL", "CATEGORY"].includes(item.type) &&
  typeof item.isComingSoon !== "boolean" && typeof item.ShowAsComingSoon !== "boolean";

export default function usePublicationMetadata(items) {
  const [metadata, setMetadata] = useState({});
  useEffect(() => {
    let active = true;
    const candidates = [...new Map((items || []).filter(needsMetadata).map(item => [item.id, item])).values()];
    if (!candidates.length) return () => { active = false; };
    Promise.all(candidates.map(async item => {
      try {
        const info = await readCache.read(`publication:${item.id}`, async () => {
          const { data } = await getContentById(item.id);
          const flag = data?.isComingSoon ?? data?.ShowAsComingSoon;
          if (typeof flag !== "boolean") throw new Error("Publication metadata unavailable");
          // Do not retain detail playback credentials or profile entitlement state.
          return { isComingSoon: flag, publicationDate: publicationStart(data) };
        }, 30000);
        return [item.id, info];
      } catch (_) {
        return [item.id, null];
      }
    })).then(entries => { if (active) setMetadata(Object.fromEntries(entries)); });
    return () => { active = false; };
  }, [items]);
  return item => ({ ...item, ...(needsMetadata(item) ? metadata[item.id] : {}),
    publicationReady: !needsMetadata(item) || !!metadata[item.id] });
}
